import styles from '@styles/scss/site/categoryCloud.module.scss';
import Link from 'next/link';
import React from 'react';

export default function CategoryCloud({
    categoryData,
    title
}: {
    categoryData: any;
    title: any;
}): JSX.Element {
    return (
        <div className={styles.categoryCloud}>
            <div className={styles.cloudTitle}>{title}</div>
            <div className={styles.cloudWrapper}>
                {categoryData.categoryCloud.map(
                    (category: any, index: number) =>
                        category.categoryName != null && (
                            <div className={styles.categoryObject}>
                                <Link prefetch={false} href={'/' + category.categorySlug}>
                                    <a
                                        data-event-category="User Action"
                                        data-event-action="Category Cloud"
                                        data-event-label={category.categoryName}>
                                        {category.categoryName}
                                    </a>
                                </Link>
                            </div>
                        )
                )}
            </div>
        </div>
    );
}
